import { values } from 'lodash';
export var MAX_PINTEREST_IMAGE_SIZE = 5000;
export var getPluginConfig = function (richContent, _a) {
    var _b = (_a === void 0 ? {} : _a).enableLinks, enableLinks = _b === void 0 ? true : _b;
    var PLUGINS = {
        IMAGE: richContent.IMAGE_TYPE,
        GALLERY: richContent.GALLERY_TYPE,
        VIDEO: richContent.VIDEO_TYPE,
        HASHTAG: richContent.HASHTAG_TYPE,
        DIVIDER: richContent.DIVIDER_TYPE,
        HTML: richContent.HTML_TYPE,
        TEXT_COLOR: richContent.TEXT_COLOR_TYPE,
        LINE_SPACING: richContent.LINE_SPACING_TYPE,
        GIPHY: richContent.GIPHY_TYPE,
    };
    if (richContent.CODE_BLOCK_TYPE) {
        PLUGINS.CODE_BLOCK = richContent.CODE_BLOCK_TYPE;
    }
    if (richContent.FILE_UPLOAD_TYPE) {
        PLUGINS.FILE_UPLOAD = richContent.FILE_UPLOAD_TYPE;
    }
    if (enableLinks) {
        PLUGINS.LINK = richContent.LINK_TYPE;
    }
    var DEFAULT_PLUGINS = values(PLUGINS);
    return { DEFAULT_PLUGINS: DEFAULT_PLUGINS, PLUGINS: PLUGINS };
};
